import { render, staticRenderFns } from "./ProjectFilesSummary.vue?vue&type=template&id=02979e25"
import script from "./ProjectFilesSummary.vue?vue&type=script&lang=ts"
export * from "./ProjectFilesSummary.vue?vue&type=script&lang=ts"
import style0 from "./ProjectFilesSummary.vue?vue&type=style&index=0&id=02979e25&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports